export default "__VITE_PUBLIC_ASSET__14e1b152__"